import { useState } from 'react';

import FacilityAffiliationTypeData from './FacilityAffiliationTypeData';

import { BASIC_INITIAL_STATE } from '../../../utils/HttpHelper';

const INITIAL_FACILITY_AFFILIATION_STATE = {
  ...BASIC_INITIAL_STATE
};

const useFacilityAffiliationTypeData = () => {
  const [facilityAffiliationTypeState, setFacilityAffiliationTypeState] = useState(INITIAL_FACILITY_AFFILIATION_STATE);

  const getFacilityAffiliationTypes = () => {
    return FacilityAffiliationTypeData.getFacilityAffiliationTypeData(facilityAffiliationTypeState, setFacilityAffiliationTypeState);
  };


  return {
    facilityAffiliationTypeState,
    getFacilityAffiliationTypes
  };
};

export default useFacilityAffiliationTypeData;